// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1F_EA","inner":"Footer_inner__11sIJ","nextIcon":"Footer_nextIcon__34Mq5","innerLeft":"Footer_innerLeft__2qSlB"};